<div class="version-badge">v{{ version }}</div>
